import { image1, image2, image3, image4 } from '../assets/images';

import React, { useEffect, useRef } from 'react';


/* Project cards now using real images with text overlays */

function PCard({ tag, name, loc, img, span, tall }) {
  return (
    <div className="reveal pcard" style={{ gridColumn: `span ${span}`, position: 'relative', overflow: 'hidden', cursor: 'pointer', borderRadius: '12px' }}>
      <div className="pimg" style={{ position: 'relative', overflow: 'hidden', aspectRatio: tall ? '16/9' : '4/3', transition: 'transform .6s ease' }}>
        <div style={{ position: 'absolute', inset: 0 }}>
          <img src={img} alt={name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </div>
        {/* Dark overlay for text readability */}
        <div style={{
          position: 'absolute', inset: 0,
          background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.3) 50%, transparent 100%)'
        }} />
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '2rem' }}>
          <div style={{
            fontFamily: 'var(--fh)', fontSize: '0.75rem', fontWeight: 600,
            letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--gold)', marginBottom: '0.5rem'
          }}>{tag}</div>
          <div style={{
            fontFamily: 'var(--fh)', fontSize: '1.5rem', fontWeight: 800,
            textTransform: 'uppercase', lineHeight: 1.1, color: '#FFFFFF'
          }}>{name}</div>
          <div style={{ fontSize: '0.9rem', color: 'rgba(255,255,255,0.7)', marginTop: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <span style={{ color: 'var(--gold)' }}>↗</span> {loc}
          </div>
        </div>
      </div>
    </div>
  );
}

/* PCard is now a stateless component defined above */

export default function Projects() {
  const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });
  return (
    <section id="projects" style={{ position: 'relative', zIndex: 1, padding: '7rem 2rem', background: 'rgba(250,250,250,0.82)' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div className="reveal" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '3rem', flexWrap: 'wrap', gap: '1rem' }}>
          <div>
            <p style={{
              fontFamily: 'var(--fh)', fontSize: '1rem', fontWeight: 600,
              letterSpacing: '0.3em', textTransform: 'uppercase', color: 'var(--gold)', marginBottom: '1rem'
            }}>Portfolio</p>
            <h2 style={{
              fontFamily: 'var(--fh)', fontSize: 'clamp(2.5rem,5vw,4rem)', fontWeight: 800,
              textTransform: 'uppercase', lineHeight: 1
            }}>
              Featured <span style={{ color: 'var(--gold)' }}>Projects</span>
            </h2>
          </div>
          <button onClick={() => scrollTo('#contact')} style={{
            background: 'transparent', color: 'var(--wh)', fontFamily: 'var(--fh)',
            fontSize: '1rem', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase',
            padding: '0.85rem 2rem', border: '1.5px solid #1E2823',
            cursor: 'pointer', transition: 'all 0.3s ease',
          }}
            onMouseEnter={(e) => { 
              e.currentTarget.style.background = 'var(--wh)';
              e.currentTarget.style.borderColor = 'var(--wh)';
              e.currentTarget.style.color = 'var(--dk)';
              e.currentTarget.style.transform = 'translateY(-3px)';
              e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.1)';
            }}
            onMouseLeave={(e) => { 
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.borderColor = '#1E2823';
              e.currentTarget.style.color = 'var(--wh)';
              e.currentTarget.style.transform = 'none';
              e.currentTarget.style.boxShadow = 'none';
            }}>
            Start Your Project →
          </button>
        </div>

        <div className="pgrid" style={{ display: 'grid', gridTemplateColumns: 'repeat(12,1fr)', gap: '1.5rem' }}>
          <PCard tag="Residential · Salem" name="Modern Villa Build" loc="RS Puram, Salem" img={image1} span={7} tall={true} />
          <PCard tag="Commercial · Coimbatore" name="Office Complex" loc="Peelamedu, Coimbatore" img={image3} span={5} tall={false} />
          <PCard tag="Tensile · Salem" name="Courtyard Canopy" loc="Fairlands, Salem" img={image4} span={5} tall={false} />
          <PCard tag="PEB · Coimbatore" name="Industrial Warehouse" loc="Kinathukadavu" img={image2} span={7} tall={true} />
        </div>
      </div>
      <style>{`
        .pcard:hover .pimg { transform: scale(1.04); }
        @media(max-width:900px){ .pgrid>*{grid-column:span 12!important} }
      `}</style>
    </section>
  );
}
